<template>
    <div class="main">
        <!-- Navigation -->
        <app-navigation></app-navigation>

        <!-- Header -->
        <!-- <app-header></app-header> -->

        <!-- Content -->
        <router-view></router-view>

        <!-- Footer -->
        <app-footer></app-footer>
        <app-cookies-consent></app-cookies-consent>
    </div>
</template>

<script>
import appFooter from "./Components/Footer.vue";
import appNavigation from "./Components/Navigation.vue";
import appCookiesConsent from "./Components/CookiesConsent.vue";

export default {
    name: "app",
    components: {
        appNavigation,
        appFooter,
        appCookiesConsent,
    },
};
</script>

<style lang="scss">
.main {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
}
</style>
